import React, { useMemo } from "react";
import FacilityPlanner from "../../../pages/FacilityPlanner";

export default function OperationsCenter({
  profile,
  selectedTenant = "",
  selectedFacility = "all",
  cardStyle,
}) {
  const operationalContext = useMemo(() => {
    const facilityId =
      selectedFacility && selectedFacility !== "all"
        ? selectedFacility
        : profile?.facilityId || profile?.primaryFacilityId || "";

    return {
      workspace: "facility_planner",
      workspaceRole: "facility_planner",
      tenantId:
        selectedTenant && selectedTenant !== "all"
          ? selectedTenant
          : profile?.tenantId || "",
      facilityId,
    };
  }, [
    selectedTenant,
    selectedFacility,
    profile?.tenantId,
    profile?.facilityId,
    profile?.primaryFacilityId,
  ]);

  const requiresFacilitySelection =
    !operationalContext.facilityId;

  return (
    <div style={{ display: "grid", gap: 12 }}>
      <div
        style={{
          ...cardStyle(),
          padding: "10px 14px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 15,
            fontWeight: 950,
            color: "#0f172a",
          }}
        >
          Operations Planner
        </div>

        <div
          style={{
            fontSize: 12,
            fontWeight: 800,
            color: "#64748b",
          }}
        >
          Live staffing board
        </div>
      </div>

      {requiresFacilitySelection ? (
        <div
          style={{
            ...cardStyle(),
            padding: "28px 24px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontSize: 17,
              fontWeight: 950,
              color: "#0f172a",
              marginBottom: 8,
            }}
          >
            Select a facility
          </div>

          <div
            style={{
              fontSize: 13,
              fontWeight: 700,
              color: "#64748b",
              lineHeight: 1.6,
            }}
          >
            Operations Planner is facility-specific. Select a facility
            from the Enterprise facility selector above to open its
            live staffing board.
          </div>
        </div>
      ) : (
        <FacilityPlanner
          profile={profile}
          operationalContext={operationalContext}
          embedded
        />
      )}
    </div>
  );
}
